exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-wrapper[data-v-a8cd1982]{padding:0 10% !important\n}\n.form-wrapper .form-wrapper-frame[data-v-a8cd1982]{padding:10px;margin:auto !important;margin-top:20px !important;border-radius:10px;box-shadow:1px 1px 20px 5px rgba(0,0,0,.2)\n}\n.form-wrapper[data-v-a8cd1982]{width:100%;padding:25px 20%\n}\n@media(max-width: 1200px){\n.form-wrapper[data-v-a8cd1982]{padding:10px .5%;margin-left:0\n}\n}\n.form-wrapper .form-wrapper-frame[data-v-a8cd1982]{width:100%;padding:25px\n}\n.title-icon[data-v-a8cd1982]{margin-top:-5px\n}\n#submit-btn[data-v-a8cd1982]{margin:25px 0;width:33%;padding:6px;font-size:1.1em\n}\n.playlist-content-table[data-v-a8cd1982]{padding:24px 0\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-a8cd1982","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/spa/playlist/PlaylistForm.vue
// module id = 170
// module chunks = 0